import BaseInput from "@common/components/Input/Input";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import styled, { css } from "styled-components";

export const BasicsItemPopover = styled.div<{ $widthPx?: number }>`
  position: relative;
  width: 24rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  box-shadow: 0 0.2rem 1rem 0 #1c1c1e;
  background-color: ${vars.colors.grey100};
  padding: 1rem 0;
  margin: 0;
  cursor: default;
  z-index: ${vars.zIndex.modalContent};
  &:focus-visible {
    border: 1px solid ${vars.colors.grey90};
    outline: transparent;
  }

  ${({ $widthPx }) =>
    $widthPx &&
    css`
      width: ${$widthPx}px;
    `}
`;

export const Input = styled(BaseInput)`
  > div {
    border-radius: 0;
    border: 0;
    border-bottom: 1px solid ${vars.colors.grey90};
    margin-bottom: 0.5rem;
    &:active,
    &:hover {
      border-bottom: 1px solid ${vars.colors.grey90};
    }
    background: transparent;
    > div {
      padding: 0 0.8rem;
    }
  }
`;

export const HitsContainer = styled(Flex)`
  max-height: 20rem;
  overflow: hidden auto;
`;

export const ClearContainer = styled(Flex)`
  border-top: 1px solid ${vars.colors.grey90};
  padding-top: 1rem;
`;

export const Helper = styled(Paragraph)`
  color: ${vars.colors.grey60};
  padding: 0.8rem 2rem;
  user-select: none;
  text-align: start;
`;

export const Label = styled.div`
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ResultText = styled.div<{ $isError?: boolean }>`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.2rem;
  padding: 1.4rem 1.8rem;
  color: ${vars.colors.grey50};
  ${(props) =>
    props.$isError &&
    css`
      color: ${vars.colors.red};
    `}
`;
